import React from 'react'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import StyledButton from '../generic/StyledButton'
import { TextField } from '@mui/material'
import { generateOtp } from '../../components/formItems/verificationCode'

const GenerateCodeV2 = ({ setOtp }) => {
  return (
    <Stack spacing={2} direction='row' alignItems={'center'} justifyContent={'left'}>
      <Typography sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>Verification Code:</Typography>
      <TextField
        onChange={(event) => setOtp(event.target.value)}
        size='small'
        sx={{
          width: '50%',
          '& .MuiOutlinedInput-root': {
            borderRadius: '0px',
            height: '35px',
          },
          '& .MuiOutlinedInput-input': {
            height: '100%',
            padding: '8px 14px',
            boxSizing: 'border-box',
          },
        }}
      />
      <StyledButton
        onClick={generateOtp}
        width='20%'
        height='35px'
        label='Generate Code'
        fontSize={14}
        borderRadius='0px'
      />
    </Stack>
  )
}

export default GenerateCodeV2
